import { render, staticRenderFns } from "./IncentivesBulkOperationPage.vue?vue&type=template&id=df85bd52&"
import script from "./IncentivesBulkOperationPage.vue?vue&type=script&lang=js&"
export * from "./IncentivesBulkOperationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports